module.exports = __webpack_public_path__ + "assets/img/Back_cover.664666ec-ps.jpg";